
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"reviewUserStepPageLoad"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usageEventsDisabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"userRoleFragment"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"submissionItem"},"name":{"kind":"Name","value":"mainItemById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"itemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"itemUnpublishedFragment"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"submissionItemDependencies"},"name":{"kind":"Name","value":"mainItemById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"itemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"itemEventFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"itemCommunityFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"itemQuestionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"contentTypes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentTypeFragment"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"subjectTypes"},"name":{"kind":"Name","value":"subjects"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"subjectTypeFragment"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"categoryTypes"},"name":{"kind":"Name","value":"categories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryTypeFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"communities"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"communityFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"SUBMISSION_OPENED"}]}},{"kind":"Argument","name":{"kind":"Name","value":"crossOrigin"},"value":{"kind":"BooleanValue","value":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"eventSubmissionFragment"},"directives":[]}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"licenseTypes"},"name":{"kind":"Name","value":"licenses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"licenseTypeFragment"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"confirmationTypes"},"name":{"kind":"Name","value":"authorConfirmations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"confirmationTypeFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"itemRejectionReasons"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"itemRejectionReasonsFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"authorTitleTypes"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1084}};
    doc.loc.source = {"body":"query reviewUserStepPageLoad($id: String!) {\n  viewer {\n    usageEventsDisabled\n\n    user {\n      ...userRoleFragment\n    }\n\n    submissionItem: mainItemById(itemId: $id) {\n      ...itemUnpublishedFragment\n    }\n\n    submissionItemDependencies: mainItemById(itemId: $id) {\n      ...itemEventFragment\n      ...itemCommunityFragment\n      ...itemQuestionFragment\n    }\n\n    contentTypes {\n      ...contentTypeFragment\n    }\n\n    subjectTypes: subjects {\n      ...subjectTypeFragment\n    }\n\n    categoryTypes: categories {\n      ...categoryTypeFragment\n    }\n\n    communities {\n      ...communityFragment\n    }\n\n    origin {\n      events: events(\n        skip: 0\n        limit: 100\n        statuses: [SUBMISSION_OPENED]\n        crossOrigin: false\n      ) {\n        results {\n          ...eventSubmissionFragment\n        }\n      }\n    }\n\n    licenseTypes: licenses {\n      ...licenseTypeFragment\n    }\n\n    confirmationTypes: authorConfirmations {\n      ...confirmationTypeFragment\n    }\n\n    itemRejectionReasons {\n      ...itemRejectionReasonsFragment\n    }\n\n    authorTitleTypes\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["reviewUserStepPageLoad"] = oneQuery(doc, "reviewUserStepPageLoad");
        
